require('./bootstrap-vue')
require('./axios')
require('./splide')
